/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_injection = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Injection volume`)
};

const es_hplc_injection = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen de inyección`)
};

const de_hplc_injection = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Injektionsvolumen`)
};

const nl_hplc_injection = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Injectievolume`)
};

const fr_hplc_injection = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume d'injection`)
};

const it_hplc_injection = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume di iniezione`)
};

const pt_br2_hplc_injection = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume de injeção`)
};

const pt_hplc_injection = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume de injeção`)
};

const ja_hplc_injection = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注入量`)
};

const zh_hplc_injection = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进样量`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_injection = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_injection(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_injection", locale)
	if (locale === "en") return en_hplc_injection(inputs)
	if (locale === "es") return es_hplc_injection(inputs)
	if (locale === "de") return de_hplc_injection(inputs)
	if (locale === "nl") return nl_hplc_injection(inputs)
	if (locale === "fr") return fr_hplc_injection(inputs)
	if (locale === "it") return it_hplc_injection(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_injection(inputs)
	if (locale === "pt") return pt_hplc_injection(inputs)
	if (locale === "ja") return ja_hplc_injection(inputs)
	return zh_hplc_injection(inputs)
};